import { Stack, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { getSvg } from '@/utils/get-svg';

export const NoAvailableBalance = () => {
  const navigate = useNavigate();

  return (
    <Stack gap={1}>
      <img
        src={getSvg('no_available_balance.svg')}
        role="img"
        width="128"
        height="128"
      />
      <Typography fontWeight={600} sx={{ marginTop: '24px' }}>
        Você não tem saldo disponível para pedir reembolso.
      </Typography>
      <Typography>
        Isso pode ser porque você já gastou todo o saldo ou porque ele ainda não
        foi renovado. Para conferir o seu saldo e histórico de uso,{' '}
        <Link onClick={() => navigate('/meus-reembolsos')}>clique aqui</Link>.
      </Typography>
    </Stack>
  );
};
